type Props = {
  label: string;
  value?: string | number;
};

const FieldRow = ({ label, value }: Props) => (
  <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
    <label style={{ fontWeight: 'bold' }}>{label}</label>
    <span>{value}</span>
  </div>
);

export default FieldRow;
